// Generated by purs version 0.15.16
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Comonad from "../Control.Comonad/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Effect_Aff_Class from "../Effect.Aff.Class/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
var pure = function (hoist) {
    return function (x) {
        return function (f) {
            return hoist(f(x));
        };
    };
};
var map = function (f) {
    return function (v) {
        return function (h) {
            return v(function (x) {
                return h(f(x));
            });
        };
    };
};
var lower$prime = function (dictApplicative) {
    var pure1 = Control_Applicative.pure(dictApplicative);
    return function (v) {
        return v(pure1);
    };
};
var lower = function (f) {
    return function (x) {
        return f(x)(function (y) {
            return y;
        });
    };
};
var liftEffect = function (dictMonadEffect) {
    var bind1 = Control_Bind.bind((dictMonadEffect.Monad0()).Bind1());
    var liftEffect1 = Effect_Class.liftEffect(dictMonadEffect);
    return function (hoist) {
        return function (x) {
            var $33 = bind1(liftEffect1(x));
            return function ($34) {
                return hoist($33($34));
            };
        };
    };
};
var liftAff = function (dictMonadAff) {
    var bind1 = Control_Bind.bind(((dictMonadAff.MonadEffect0()).Monad0()).Bind1());
    var liftAff1 = Effect_Aff_Class.liftAff(dictMonadAff);
    return function (hoist) {
        return function (x) {
            var $35 = bind1(liftAff1(x));
            return function ($36) {
                return hoist($35($36));
            };
        };
    };
};
var lift = function (dictFunctor) {
    var map1 = Data_Functor.map(dictFunctor);
    return function (f) {
        return function (x) {
            return function (g) {
                return f(map1(g)(x));
            };
        };
    };
};
var lift$prime = function (dictComonad) {
    var extract = Control_Comonad.extract(dictComonad);
    return function (dictFunctor) {
        return lift(dictFunctor)(Data_Functor.map(dictFunctor)(extract));
    };
};
var bind = function (hoist) {
    return function (v) {
        return function (v1) {
            return function (g) {
                return v(function (x) {
                    return hoist(v1(x)(g));
                });
            };
        };
    };
};
var apply = function (hoist) {
    return function (v) {
        return function (v1) {
            return function (g) {
                return v(function (f) {
                    return hoist(v1(function ($37) {
                        return g(f($37));
                    }));
                });
            };
        };
    };
};
export {
    apply,
    bind,
    lift,
    lift$prime,
    liftAff,
    liftEffect,
    lower,
    lower$prime,
    map,
    pure
};
//# sourceMappingURL=index.js.map
